export default __webpack_public_path__ + "static/media/ecommerce2.50bad733.gif";